import { useEffect } from 'react';

const useOutsideComponentClick = (ref: React.RefObject<HTMLElement>, onClose: () => void, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    const handleOutsideClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        event.stopPropagation();
        onClose();
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [ref, onClose, enabled]);
};

export default useOutsideComponentClick;
